import { useConfigStore } from '@/store/config.store';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

// A scene is built to the size of the zone and cannot be resized afterwards (FabricScene keeps the
// dimensions it was given), so a shell that keys its canvases on this has them rebuilt, from the
// template store, whenever the product is cut to another zone: the band, the faces, the height
// that follows the quantity.
function useSceneZoneKey() {
    const { product } = storeToRefs(useConfigStore());

    return computed(() => (product.value ? `${product.value.width}x${product.value.height}` : 'no-zone'));
}

export { useSceneZoneKey };
